import { render } from "./GastosPage.vue?vue&type=template&id=07030b43"
import script from "./GastosPage.vue?vue&type=script&lang=js"
export * from "./GastosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__